import { badges } from './badge';
import { level1, level2 } from './level';
export var member123 = {
  __typename: 'Member',
  id: '123',
  name: 'Alice',
  age: 32,
  avatarUrl: '/_next_public/avatars/batman.svg',
  lifetimePoints: 100,
  title: 'CEO',
  company: 'Influitive',
  isAdmin: true,
  level: {
    id: '2',
    name: level2.name,
    rank: 2,
    badges: [{
      id: '2',
      name: 'Badge 2',
      imageUrl: 'https://static.influitive.com/influitiveimages/hq/icons/badges/default/hq-badge-replies-01.png?1580484236',
      description: 'Quisque quis ultrices massa, ut pharetra sapien. Suspendisse potenti.',
      dateAwarded: '2021-04-06T12:37:25Z',
      level2: level2
    }]
  },
  badges: badges,
  showOnLeaderBoard: true
};
export var member234 = {
  __typename: 'Member',
  id: '234',
  name: 'Mallory',
  age: 56,
  avatarUrl: '/_next_public/avatars/grandma.svg',
  lifetimePoints: 100,
  title: '',
  company: 'Influitive',
  isAdmin: true,
  level: level1,
  showOnLeaderBoard: true
};
export var member345 = {
  __typename: 'Member',
  id: '345',
  name: 'Bob',
  age: 45,
  avatarUrl: '/_next_public/avatars/bear.svg',
  lifetimePoints: 100,
  title: '',
  company: '',
  isAdmin: false,
  level: level1,
  badges: [],
  showOnLeaderBoard: true
};
export var member456 = {
  __typename: 'Member',
  id: '456',
  name: 'Kurt Wagner',
  age: 45,
  avatarUrl: 'https://s3.amazonaws.com/influitiveimagesdevelopment/app/contacts/original/61.jpg?1596637829',
  lifetimePoints: 100,
  title: 'Nightcrawler',
  company: 'The X-Men',
  isAdmin: false,
  level: level1,
  badges: [],
  showOnLeaderBoard: true
};
export var member678 = {
  id: '678',
  name: 'Pietro Maximoff',
  avatarUrl: null,
  title: 'Quicksilver',
  company: 'The X-Men',
  isAdmin: false
};